import { useState } from "react";
import FeeScheduleExistingTemplate from "work/fee-schedule-templates/_views/lists/fee-schedule-template-list";
import FeeScheduleTemplateCategoryPicker, {
  type TemplateCategoriesApplied,
  type TemplateCategory,
} from "work/fee-schedule-templates/_views/lists/fee-schedule-template-category-picker";
import type FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";

type ExistingFeeScheduleTemplatePickerProps = {
  /** What the schedule being built already holds. */
  existingCategories: readonly TemplateCategory[];
  onApply: (applied: TemplateCategoriesApplied) => void;
  onCancel: () => void;
};

/**
 * Select Existing Template, in two steps (#6604): choose a template from the list, then look over its
 * categories and take the ones wanted. Back returns to the list. Used by the fee schedule template page's
 * drawer and the marketplace team fee schedule editor's dialog alike.
 */
export default function ExistingFeeScheduleTemplatePicker(props: Readonly<ExistingFeeScheduleTemplatePickerProps>) {
  const { existingCategories, onApply, onCancel } = props;
  const [previewed, setPreviewed] = useState<FeeScheduleTemplate>();

  if (previewed) {
    return (
      <FeeScheduleTemplateCategoryPicker
        // A different template starts its own ticks afresh.
        key={previewed.id?.value ?? previewed.name}
        template={previewed}
        existingCategories={existingCategories}
        onBack={() => setPreviewed(undefined)}
        onApply={onApply}
      />
    );
  }

  return <FeeScheduleExistingTemplate onTemplateSelected={setPreviewed} onCancel={onCancel} />;
}
